const segmenter = new Intl.Segmenter('ko', { granularity: 'grapheme' })

// 유저가 인식하는 실제 글자(grapheme) 수를 반환
// ex) "가나다" → 3, "호스트👩‍❤️‍💋‍👩" → 4
export const getGraphemeLength = (text: string): number => {
  return [...segmenter.segment(text)].length
}

// 글자(grapheme) 수 기준으로 문자열을 자름
export const sliceByGrapheme = (text: string, maxLength: number): string => {
  const segments = [...segmenter.segment(text)]

  if (segments.length > maxLength) {
    return segments
      .slice(0, maxLength)
      .map(s => s.segment)
      .join('')
  }

  return text
}
